export const isOdd = (n) => n % 2 !== 0;
//# sourceMappingURL=isOdd.js.map